import React from 'react';
import { motion } from 'framer-motion';
import { CONTACTS } from '../constants/info';
import '../assets/css/Footer.css';

const Footer = () => (
  <motion.footer
    className="footer-section justify-content-center align-items-center"
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.3 }}
    transition={{ duration: 0.6 }}
  >
    <div className="footer-container">
      <div className="footer-top-row">
        <div className="footer-brand-info-left">
          <img src="/logo-nb.png" alt="Talatona Kids Logo" className="footer-logo" />
        </div>
        <div className="footer-brand-info-right">
          <a href={`tel:${CONTACTS.phone.replace(/[^\d+]/g, '')}`} className="footer-link">
            <i className="bi bi-whatsapp"></i> {CONTACTS.phone}
          </a>
          <a href={CONTACTS.facebook} className="footer-link" target="_blank" rel="noopener noreferrer">
            <i className="bi bi-facebook"></i> @talatonakids
          </a>
          <a href={CONTACTS.instagram} className="footer-link" target="_blank" rel="noopener noreferrer">
            <i className="bi bi-instagram"></i> @talatona_kids
          </a>
          <a href={`mailto:${CONTACTS.email}`} className="footer-link">
            <i className="bi bi-envelope-fill"></i> {CONTACTS.email}
          </a>
          <a href={CONTACTS.maps} className="footer-link" target="_blank" rel="noopener noreferrer">
            <i className="bi bi-geo-alt-fill"></i> {CONTACTS.address}
          </a>
        </div>
      </div>
      <div className="footer-divider "></div>
      <div className="footer-contact-info justify-content-center">
        <div className="footer-copyright-text">
          &copy; {new Date().getFullYear()} Talatona Kids. Todos os direitos reservados.
        </div>
      </div>
    </div>
  </motion.footer>
);

export default Footer;